export const FADE_OUT_WIDTH = 280;
export const HIDE_WIDTH = 210;
